import {
  useBooleanFlagValue,
  useObjectFlagValue,
} from '@openfeature/react-sdk';

export function useFeatureFlags() {
  const assetLibrary = useBooleanFlagValue('cms-asset-library', false);
  const bannerAnnouncement = useObjectFlagValue('cms-banner-announcement', {
    enabled: false,
    href: '',
  });
  const maintenanceMode = useBooleanFlagValue('cms-maintenance-mode', false);

  return {
    assetLibrary,
    bannerAnnouncement,
    maintenanceMode,
  };
}
